import React from "react";
import { toast } from "sonner";
import { Download } from "lucide-react";
import DashboardShell from "@/layouts/ProviderDashboardLayout";
import ImportWizard from "@/pages/admin/datacenter/ImportWizard";
import { Btn, download } from "@/components/datacenter/ui";

export default function ProviderServicesImportPage() {
  const exp = () => download("get", "/provider-import/export/services.csv", null, "my_services.csv").then((n) => toast.success(`Exported ${n} services`)).catch(() => toast.error("Only approved providers can export"));
  return (
    <DashboardShell>
      <div className="flex justify-end mb-2"><Btn kind="ghost" onClick={exp} tid="provider-export-services"><Download className="h-4 w-4" /> Export my services</Btn></div>
      <ImportWizard base="/provider-import" route="/dashboard/services/import" admin={false} />
    </DashboardShell>
  );
}
